import Cookies from "js-cookie";

const user = {
    state: {
        headPortrait: "",
        park: ""
    },

    mutations: {
        setPortrait(state, portrait) {
            state.headPortrait = portrait;
        },
        setPark(state, park) {
            state.park = park;
        },
        logout(state, vm) {
            Cookies.remove("user");
            Cookies.remove("password");
            Cookies.remove("access");
            // localStorage.clear();
        }
    }
};

export default user;
